export const TOTALDONATIONSTHISMONTH_LABELS = {
  counter: {
    en: "Total Donations (Amount) - This Month",
    ta: "மொத்த நன்கொடைகள் (தொகை) - இந்த மாதம்",
    si: "මුළු පරිත්‍යාග (මුදල)​ - මෙම මාසය",
  },
};
